
const getPois = (state) => { return state.pois }

const getPublicProducts = (state) => { return state.publicProducts }

const getBarChartArrecadacao = (state) => { return state.barChartArrecadacao }

const getBarChartProdutividade = (state) => { return state.barChartProdutividade }

const getBarChartHorario = (state) => { return state.barChartHorario }

const getBarChartVisitantes = (state) => { return state.barChartVisitantes }

const getBarChartTamanho = (state) => { return state.barChartTamanho }

const getDoughnutChartVisitantes = (state) => { return state.doughnutChartVisitantes }

const getBarChartRankingVisitantes = (state) => { return state.barChartRankingVisitantes }

const getStateYesterdayTotalClients = (state) => { return state.stateYesterdayTotalClients }

const getStateTomorrowTotalClients = (state) => { return state.stateTomorrowTotalClients }

const getStateTodayTotalClients = (state) => { return state.stateTodayTotalClients }

const getStateFilteredBillItensAmount = (state) => { return state.stateFilteredBillItensAmount }

const getUseChartCache = (state) => { return state.useChartCache }

const getIsLoading = (state) => { return state.isLoading }

const getChartCacheLimit = (state) => {
    if (!state.cacheLimiteDate) {
        var cacheLimiteDate = new Date()
        cacheLimiteDate.setTime(cacheLimiteDate.getTime() - 1 * 60 * 1000)
        return cacheLimiteDate.getTime()
    }
    return state.cacheLimiteDate
}

export default {
    getPois,
    getPublicProducts,
    getIsLoading,
    getUseChartCache,
    getChartCacheLimit,
    getBarChartArrecadacao,
    getBarChartProdutividade,
    getBarChartHorario,
    getBarChartVisitantes,
    getBarChartTamanho,
    getDoughnutChartVisitantes,
    getBarChartRankingVisitantes,
    getStateYesterdayTotalClients,
    getStateTomorrowTotalClients,
    getStateTodayTotalClients,
    getStateFilteredBillItensAmount,
}
